import Swiper, { Navigation, Autoplay } from 'swiper';
export default {
  init() {
    // JavaScript to be fired on the home page
    Swiper.use([Navigation, Autoplay]);


    // BANNER HOME
    $('.js_banner-home-btn-scroll').on('click', function() {
        $('html,body').stop().animate({
            scrollTop: $(this).offset().top + $(this).outerHeight(true),
        }, 1000);
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
